import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { TabsList, TabsItem } from '../Tabs';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function ContentTabsList(props) {
  return <TabsList type="menu-filled" {...props} />;
}

export function ContentTabsItem({ className, isMobile, ...otherProps }) {
  return (
    <TabsItem {...otherProps} className={cx('component', isMobile && 'mobileLayout', className)} />
  );
}

ContentTabsItem.propTypes = {
  // TODO: add more props
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
